import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getCoinagencyInfo = createAsyncThunk(
  'CoinAgencyWallet/getCoinagencyInfo',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/get_ra_info', params, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const homepage = createAsyncThunk(
  'CoinAgencyWallet/homepage',
  async (params: any, store: any) => {
    const resp = await http.post('/live/merchant/homepage', params, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

// 币商banner http://wiki.xunlei.cn/pages/viewpage.action?pageId=92444874
export const get_banners = createAsyncThunk(
  'CoinAgencyWallet_get_banners',
  async (params, store: any) => {
    const resp = await http.post('/live/misc/get_banners', params, {
      store,
      xcErrorToast: true,
    })
    return resp?.data?.data?.banner_list || []
  }
)
interface InitialStateType {
  coinagencyInfo?: any
  banner_list?: Array<any>
  home?: any
}

const initState: InitialStateType = {}
const initData: InitialStateType = {
  coinagencyInfo: {
    current_amount: 0,
    trade_allowed: false, // 准币商不展示sale coins按钮
    count_down: 0,
    senior_show_id: 0, // 工会id
    status: 0, //  0普通用户  1上家异常的分销商  2上家正常的分销商  3考核期币商  4普通币商  5高级币商
    pre_status: 0, // 七日内最高
    is_super: false, // true:是超级币商
  },
  banner_list: [],
  home: {},
}

export const AgencyWallet = createSlice({
  name: 'Animal_Heron',
  initialState: initState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state.home, action.payload)
    })
    builder.addCase(getCoinagencyInfo.fulfilled, (state, action) => {
      Object.assign(state.coinagencyInfo, action.payload)
    })
    builder.addCase(get_banners.fulfilled, (state, action) => {
      Object.assign(state.banner_list, action.payload)
    })
  },
})

export default AgencyWallet.reducer
export const AgencyWalletActions = AgencyWallet.actions
